import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'redux-zero/react';
import { injectIntl } from 'react-intl';

import JobCard from './careers-card.component.js';
import CareersDetailService from './careers.service.js';
import { actions } from '../../shared/store.js';
import NotImplemented from '../../components/not-implemented/page-not-implemented.js';
import { Button } from '../../components/ui-toolkit/buttons.js';
import ScrollToTop from '../../shared/utils.js';
import Seo from '../../infrastructure/seo.js';

import './careers.scss';

class CareersListPageInternal extends Component {
	static prefetchData = async language => Promise.all([
		CareersDetailService.getCareers(language),
		CareersDetailService.getPageData(language),
	]);

	state = {
		hasError: false,
	};

	componentDidMount() {
		ScrollToTop();
		if (!this.props.careers || !this.props.careersPageData) {
			this.fetchData();
		} else {
			this.props.setLoading(false);
		}
	}

	componentDidUpdate(prevProps) {
		ScrollToTop();
		if (
			this.props.language.value !== prevProps.language.value
			|| this.props.location.search !== prevProps.location.search
		) {
			this.fetchData();
		}
	}


	fetchData() {
		this.props.setLoading(true);
		CareersListPageInternal.prefetchData(this.props.language.value)
			.then((data) => {
				this.props.setCareers(data[0]);
				this.props.setCareersPageData(data[1]);
				this.props.setLoading(false);
			})
			.catch((error) => {
				this.props.setLoading(false);
				this.setState({
					hasError: true,
				});
				console.log(error);
			});
	}

	render() {
		const {
			intl: { formatMessage }, addresses, phones, generalData,
		} = this.props;

		const { careers, careersPageData } = this.props;

		const { hasError } = this.state;

		if (!careers || !careersPageData || hasError) return <NotImplemented title="Careers" />;

		return (
			<div className="careers">
				<Seo
					title={formatMessage({ id: 'navigation.careers' })}
					description={(careersPageData && careersPageData.description) || formatMessage({ id: 'navigation.careers' })}
					microdata={`{
									"@context": "https://schema.org",
									"@graph": [
										{
											"@type": "AboutPage",
											"name": "${careersPageData && careersPageData.title}",
											"description": "${careersPageData && careersPageData.description}"
										},
										{
											"@type": "WebApplication",
											"name": "Inocrowd",
											"url": "${process.env.REACT_APP_WEBSITE_ENDPOINT}",
											"applicationCategory": "BusinessApplication",
											"operatingSystem": "Windows, Linux, OSX, iOS, Android",
											"sameAs": [
												"${process.env.REACT_APP_PLATFORM_ENDPOINT}",
												"https://www.facebook.com/InoCrowd/",
												"https://www.linkedin.com/company/inocrowd",
												"https://twitter.com/InoCrowd",
												"https://www.instagram.com/inocrowd",
												"https://www.youtube.com/channel/UC8JotJA9Txz_6NQXWuEwdvQ"
											],
											"provider": {
												"@type": "Organization",
												"name": "Inocrowd",
												${addresses.length > 0 && `
													"address":  "${addresses[0].description.replace(/\n/g, ' ')}",
												`}
												${phones.length > 0 && `
													"contactPoint": {
														"@type": "ContactPoint",
														"telephone": "${phones[0].phoneNumber}",
														"contactType": "customer service"
													},
													"telephone": "${phones[0].phoneNumber}",
												`}
												${generalData && generalData.logo ? `
													"logo": "${process.env.REACT_APP_API_ENDPOINT}${generalData.logo.path}"
												` : ''}
											}
										},
										{
											"@type": "BreadcrumbList",
											"itemListElement": [
												{
													"@type": "ListItem",
													"name": "Inocrowd",
													"position": 1,
													"item": "${process.env.REACT_APP_WEBSITE_ENDPOINT}"
												},
												{
													"@type": "ListItem",
													"name": "${formatMessage({ id: 'navigation.careers' })}",
													"position": 2,
													"item": "${process.env.REACT_APP_WEBSITE_ENDPOINT}/careers"
												}
											]
										}
									]
								}`}
				/>
				<div className="container container-fluid section">
					<div className="row careers-top">
						<div className="col-lg-4 col-md-4 col-sm-12 careers-section-title">
							<span>{careersPageData.title}</span>
						</div>
						<div className="col-lg-8 col-md-8 col-sm-12 careers-section-description">
							<span>{careersPageData.description}</span>
						</div>
					</div>
				</div>

				{
					careersPageData.image.path
				&&				(
					<div
						className="full-image"
						style={{ backgroundImage: `url('${process.env.REACT_APP_API_ENDPOINT}/${careersPageData.image.path}')` }}
					/>
				)
				}

				<div className="container container-fluid">
					<div className="careers-list-section">
						<div className="careers-section-title section">
							<span>{careersPageData.title2}</span>
						</div>
						<div className="row careers-list">
							 {careers
							 && careers.map(entry => <JobCard formatMessage={formatMessage} key={entry.id} {...entry} />)
							 }
						</div>
						<div className="section">
							<div className="jobs-list-description ">
								<span>{careersPageData.description2}</span>
							</div>
							<div className="button-apply-now sub-section">
								<Button className="btn-color-theme-2" to="/careers/self-apply/apply">
									{formatMessage({ id: 'careers.button' })}
								</Button>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

const mapToProps = ({ language, careers, careersPageData, addresses, phones, generalData }) => ({
	language,
	careers,
	careersPageData,
	addresses,
	phones,
	generalData,
});
export default connect(
	mapToProps,
	actions,
)(withRouter(injectIntl(CareersListPageInternal)));


export { CareersListPageInternal };
